import { CalendarIcon } from "lucide-react";

import { Row } from "@/components";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { dates } from "@/lib/dates";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { dateFilterToLabel } from "@/lib/constants";
import { DateFilterOption, LeaderboardQueryParams } from "@/types";

export const LeaderboardTableQueryOptions = ({
  queryParams,
  setQueryParams,
}: {
  queryParams: LeaderboardQueryParams;
  setQueryParams: (params: LeaderboardQueryParams) => void;
}) => {
  return (
    <Row className="items-center gap-1">
      {Object.entries(dateFilterToLabel)
        .filter(
          ([key]) => (key as DateFilterOption) !== DateFilterOption.Custom,
        )
        .map(([key, label]) => (
          <Button
            key={key}
            className="h-8"
            variant={
              queryParams.timePeriod === (key as DateFilterOption)
                ? "default"
                : "outlineSecondary"
            }
            onClick={() => {
              const timePeriod = key as DateFilterOption;
              mixpanelUtils.trackFilterAndSortOptionSelected(
                MIXPANEL_SCREENS.LEADERBOARD,
                "Time Period",
                timePeriod,
              );
              const dateRange = dates.handleDateRangeFilter(timePeriod);
              setQueryParams({
                ...queryParams,
                timePeriod,
                dateRange,
              });
            }}
          >
            {label}
          </Button>
        ))}
      <Popover>
        <PopoverTrigger asChild>
          <Button
            className="h-8 w-8 px-0"
            variant={
              queryParams.timePeriod === DateFilterOption.Custom
                ? "default"
                : "outlineSecondary"
            }
          >
            <CalendarIcon className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto overflow-auto p-0" align="end">
          <Calendar
            mode="range"
            selected={queryParams.dateRange}
            onSelect={(dateRange) => {
              mixpanelUtils.trackFilterAndSortOptionSelected(
                MIXPANEL_SCREENS.LEADERBOARD,
                "Time Period",
                DateFilterOption.Custom,
              );
              setQueryParams({
                ...queryParams,
                timePeriod: DateFilterOption.Custom,
                dateRange,
              });
            }}
          />
        </PopoverContent>
      </Popover>
    </Row>
  );
};
